import type { DataLayerInfo, PageInfo } from '../../../../shared/types'

export const getNewsSubVerticalDataLayer = (pageInfo: PageInfo) => {
  const newsDataLayer: DataLayerInfo = {
    ...pageInfo,
    vertical: pageInfo.sub_vertical || pageInfo.vertical,
    content_type: 'news',
    pageType: 'news-vertical',
  }

  delete newsDataLayer.sub_vertical

  return newsDataLayer
}
